import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import { removeAuthToken } from "../../security/tokenUtils";
import axiosInstance from "../../utils/axiosInstance";

const fetchData = async (url, options = {}) => {
  let loading = true;

  try {
    let response;

    if (options.method === "POST") {
      response = await axiosInstance.post(url, options.data, options.config);
    } else if (options.method === "PUT") {
      response = await axiosInstance.put(url, options.data, options.config);
    } else if (options.method === "DELETE") {
      response = await axiosInstance.delete(url, options.config);
    } else {
      response = await axiosInstance.get(url, options.config);
    }

    loading = false;
    return { data: response.data, loading, error: null };
  } catch (error) {
    loading = false;

    if (error.response.status === 401) {
      ErrorAlert("Desconnexió per inactivitat, torni a iniciar la sessió.");
      removeAuthToken();
      //window.location.reload();
    }

    return { data: [], loading, error };
  }
};

export default fetchData;
